
<template>
  <fade-in-main>
    <form v-on:submit="$router.push('/contact/confirm')">
      <div class="form-wrapper">
        <table>
          <tr>
            <td>お名前</td>
            <td>
              <input type="text" placeholder="田中 太郎"
              v-model="user.nameKanzi"
              required />  
            </td>
          </tr>
          <tr>
            <td>フリガナ</td>
            <td>
              <input type="text" placeholder="タナカ タロウ"
              v-model="user.nameKata"
              required> 
            </td>
          </tr>
          <tr>
            <td>メールアドレス</td>
            <td>
              <input type="email" placeholder="xxx@example.com"
              v-model="user.adress"
              required>
            </td>
          </tr>
          <tr>
            <td>電話番号</td>
            <td>
              <input type="tel" placeholder="000-0000-0000"
              v-model.number="user.tel"
              required>
            </td>
          </tr>
          <tr>
            <td>メッセージ本文</td>
            <td>
              <textarea type="text" placeholder="本文を入力してください"
              v-model="user.contents"
              required></textarea>
            </td>
          </tr>
        </table>
      </div>
      <div class="form-submit">
        <button>確認する</button>
      </div>
    </form>
  </fade-in-main>
</template>



<script>
import FadeInMain from '../components/FadeInMain.vue';

export default {
  props: {
    user: Object
  },
  components: {
    FadeInMain
  }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
  display: flex;
  justify-content: center;
  margin: 50px auto;
}

table td:nth-child(1) {
  text-align: right;
  padding-right: 20px;
  vertical-align: top;
}

table td:nth-child(2) {
  text-align: left;
}

table td {
  padding-bottom: 20px;
}
</style>